/* ═══════════════════════════════════════════════════════════════════════════
   ALIA · booking widget + private-events lead form
   Theme: r12-three-nights

   Ported from c01-after-dark. ONLY the :host token block below was changed.
   Three Nights publishes --char / --roast / --amber / --bone / --espresso /
   --parchment plus the two greens (--cta-green and BOTH --cta-green-dark and
   --cta-green-d, since this theme's stylesheet defines each once). It does not
   publish --roast-deep or --edge-soft, so those are resolved to Three Nights
   literals here rather than falling back to After Dark's values.

   Shadow-DOM isolated. Every colour is var(--theme-token, <that token's own
   value>): custom properties inherit through the shadow boundary, so the
   widget reads the theme's live :root and the literal fallback is the same
   value in case the stylesheet fails. Type is the theme's own Chivo /
   Chivo Mono — @font-face is document-scoped, so it resolves in here.

   TRAP A — the [data-act] click handler is bound to `document`, not to the
   shadow root. Shadow DOM is a boundary in BOTH directions: a listener on the
   shadow root never sees the Corporate buttons out on the page, so every CTA
   in the header, hero, lanes, bands, blog and articles would silently do
   nothing. One document-level handler walking e.composedPath() covers page
   buttons and shadow buttons alike, with no double-firing.

   Config comes from window.ALIA_CFG, emitted by layout/theme.liquid out of
   theme settings, so the phone / OpenTable / endpoint live in the theme editor
   rather than in this file. There is deliberately NO email anywhere: if the
   POST fails the form shows the phone number.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (document.getElementById('alia-wgt-host')) return;

  var C = window.ALIA_CFG || {};
  var CFG = {
    phoneHref:  C.phoneHref  || 'tel:+15145662542',
    phoneLabel: C.phoneDisplay || '(514) 566-2542',
    openTable:  C.openTable  || 'https://www.opentable.ca/r/alia-montreal',
    endpoint:   C.endpoint   || '',
    site:       C.site       || C.domain || location.hostname
  };
  var DEMO = !CFG.endpoint;

  var CSS = `
  :host{
    /* Three Nights publishes --char / --roast / --amber / --bone. The ramp
       steps between --char and --roast are interpolated here so the panel,
       wells and modal still read as separate layers. */
    --w-ground:   #1A120B;
    --w-roast:    var(--char,#241A11);
    --w-panel:    #2E2116;
    --w-panel-2:  #3A2A1B;
    --w-deep:     var(--roast,#4A331F);
    --w-ink:      var(--bone,#EEEDE3);
    --w-mute:     rgba(238,237,227,.60);
    --w-mute-2:   rgba(238,237,227,.38);
    /* Three Nights' own hairline value, not After Dark's .08 */
    --w-line:     rgba(238,237,227,.12);
    --w-line-am:  rgba(138,95,58,.30);
    --w-amber:    var(--amber,#8A5F3A);
    --w-amber-lit:#B07A48;
    --w-amber-hot:#C99560;
    --w-green:    var(--cta-green,#1FA35B);
    --w-green-d:  var(--cta-green-d,#17824A);
    --w-ease:     var(--ease,cubic-bezier(.22,1,.36,1));
    --w-ff:'Chivo',system-ui,-apple-system,sans-serif;
    --w-mono:'Chivo Mono',monospace;
    --w-inset:clamp(16px,3vw,30px);
    /* Three Nights is square everywhere — radius 0 on every .btn, panel and
       input. A rounded widget would read as bolted on. */
    --w-radius:0px;
    /* TRAP B — the placeholder must be dim against the VALUE colour, not just
       against the well. Kept at After Dark's value: the well and --bone are
       the same here, so the measured 3.87:1 / 3.03:1 still hold. */
    --w-hint:#7C7668;
    --w-well:#3A2A1B;
    --w-well-hi:#45321F;
    --w-well-fo:#4C3724;
    --w-err:#C4713F;
    --w-err-lit:#E0705E;

    /* Three Nights stacks its fixed chrome high: #nav 9997, #progress and
       #drawer 9998, #cursor 9999, #preloader 10000. At c01's 9600 the nav
       painted straight over the modal header and swallowed the close button.
       9999 clears the nav, the progress bar and the drawer, and still sits
       under the preloader so the widget can never flash over the intro. */
    position:fixed;inset:0;z-index:9999;pointer-events:none;
    font-family:var(--w-ff);line-height:1.6;color:var(--w-ink);
  }
  *{box-sizing:border-box;margin:0}
  button{font-family:inherit;cursor:pointer;border:none;background:none;color:inherit}
  :host *:focus-visible{outline:2px solid var(--w-amber-lit);outline-offset:3px;border-radius:2px}
  [hidden]{display:none!important}
  @keyframes w-rise{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
  @keyframes w-halo{0%,100%{transform:scale(1);opacity:.45}50%{transform:scale(1.14);opacity:0}}

  /* ── buttons: the theme's own .btn / .btn.ghost, including the green
        !important overrides from style blocks 2 and 4 ── */
  .cta{
    position:relative;display:inline-flex;align-items:center;justify-content:space-between;gap:12px;
    font-family:var(--w-mono);font-size:12px;letter-spacing:.2em;text-transform:uppercase;
    text-decoration:none;border-radius:var(--w-radius);padding:15px 20px;width:100%;
    transition:transform .3s var(--w-ease),background .3s,box-shadow .3s,color .3s,border-color .3s;
  }
  .cta.primary{background:var(--w-green);color:#fff;font-weight:700}
  .cta.primary:hover{background:var(--w-green-d);transform:translateY(-2px);box-shadow:0 12px 34px rgba(31,163,91,.28)}
  .cta.ghost{background:transparent;color:var(--w-green);border:1px solid var(--w-green)}
  .cta.ghost:hover{background:var(--w-green);color:#fff}
  .cta .lab{display:flex;flex-direction:column;line-height:1.25;text-align:left}
  .cta .sub{font-size:9.5px;letter-spacing:.26em;opacity:.82;font-weight:400}
  .cta .arr{transition:transform .3s var(--w-ease)}
  .cta:hover .arr{transform:translateX(5px)}

  /* ── launcher: green disc, white "?" that flips to "×" ── */
  .fab{
    position:fixed;right:var(--w-inset);bottom:var(--w-inset);pointer-events:auto;
    width:58px;height:58px;border-radius:50%;
    border:1px solid var(--w-green);background:var(--w-green);
    color:#fff;font-family:var(--w-ff);font-size:27px;font-weight:700;line-height:1;
    display:grid;place-items:center;
    box-shadow:0 10px 34px -8px rgba(31,163,91,.85);
    transition:transform .2s var(--w-ease),background .2s;
  }
  .fab:hover{background:var(--w-green-d);transform:scale(1.06)}
  .fab::before{
    content:"";position:absolute;inset:-7px;border-radius:50%;
    border:1px solid var(--w-green);opacity:.45;
    animation:w-halo 3.4s ease-in-out infinite;pointer-events:none;
  }
  .fab.open::before{animation:none;opacity:0}

  /* ── panel ── */
  .panel{
    position:fixed;right:var(--w-inset);bottom:calc(var(--w-inset) + 70px);
    pointer-events:auto;width:min(330px,calc(100vw - 32px));
    display:flex;flex-direction:column;gap:8px;
    /* TRAP C — opaque colour, gradient in background-image, so a hero photo
       behind the panel can never read through the copy. */
    background-color:var(--w-panel);
    background-image:linear-gradient(180deg,rgba(224,168,103,.05),transparent 42%);
    border:1px solid var(--w-line);border-top:1px solid var(--w-amber);
    padding:20px;box-shadow:0 26px 60px -18px rgba(0,0,0,.9);
    animation:w-rise .26s var(--w-ease);
  }
  .p-title{font-size:1.1rem;font-weight:400;letter-spacing:-.01em}
  .p-sub{margin-bottom:8px;font-size:13.5px;color:var(--w-mute)}
  .p-note{
    margin-top:10px;font-family:var(--w-mono);font-size:10.5px;letter-spacing:.14em;
    text-transform:uppercase;color:var(--w-amber-lit);
  }

  /* ── lead form ── */
  .scrim{
    position:fixed;inset:0;pointer-events:auto;
    background:rgba(21,13,7,.84);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);
    display:none;align-items:center;justify-content:center;overflow-y:auto;
    /* Clear the fixed 68px bar at the top. Centring alone is not enough: once
       the modal is taller than the free height it overflows equally in both
       directions and the header — with the close button in it — goes up under
       the nav where it cannot be reached. */
    padding:84px 16px 16px;
  }
  .scrim.on{display:flex}
  .modal{
    position:relative;width:min(830px,100%);max-height:min(92svh,900px);
    display:flex;flex-direction:column;
    background-color:var(--w-roast);
    border:1px solid var(--w-line);
    animation:w-rise .25s var(--w-ease);
  }
  .m-head{
    flex:none;display:flex;justify-content:space-between;align-items:flex-start;gap:20px;
    padding:20px 26px 14px;border-bottom:1px solid var(--w-line);
  }
  .m-eye{
    font-family:var(--w-mono);font-size:11px;letter-spacing:.42em;text-transform:uppercase;
    color:var(--w-amber);
  }
  .m-title{
    font-family:var(--w-ff);font-weight:300;text-transform:uppercase;
    font-size:clamp(22px,3.2vw,32px);line-height:1.06;letter-spacing:.03em;margin:8px 0 6px;
  }
  .m-sub{font-size:14px;color:var(--w-mute);max-width:46ch}
  .m-x{
    flex:none;width:34px;height:34px;border:1px solid var(--w-line);
    color:var(--w-mute);font-size:16px;line-height:1;transition:color .2s,border-color .2s;
  }
  .m-x:hover{color:var(--w-amber-hot);border-color:var(--w-amber)}
  /* head : body : foot, with only the MIDDLE one scrolling. The Send button
     lives in the foot, outside the scroll box, so it is on screen at every
     viewport height — no amount of trimming field padding can guarantee that
     on its own, and a submit button you have to hunt for is a dead form. */
  .m-body{flex:1 1 auto;min-height:0;display:flex;flex-direction:column;overflow:hidden;padding:0}
  .m-body form{display:flex;flex-direction:column;min-height:0;flex:1 1 auto}
  .m-scroll{
    flex:1 1 auto;min-height:0;overflow-y:auto;padding:18px 26px 8px;
    -webkit-overflow-scrolling:touch;   /* momentum scrolling on older iOS */
    overscroll-behavior:contain;        /* do not chain the scroll to the page behind */
    touch-action:pan-y;                 /* claim the vertical drag for this box */
  }

  /* The scrollbar CHROME is removed, not the scrolling. The UA paints a light
     default bar inside the shadow root — the theme's own ::-webkit-scrollbar
     rules are document-scoped and never reach in here — and a grey bar down a
     dark dialog looks like a bug. Hiding it keeps wheel, trackpad, touch and
     keyboard scrolling intact, which matters: max-height is what keeps the
     dialog on screen, and with scrolling actually disabled the Send button
     would be unreachable on any short viewport. */
  /* The BACKDROP never wants a bar. The scroll box does — but a slim amber
     one, not the UA default grey that looked broken against the dialog.
     overflow-y:auto only paints a bar when the content actually overflows,
     so this is self-hiding: absent when the form fits, present the moment a
     conditional field pushes it past the available height. Hiding it
     outright is what made a cut-off textarea read as a bug rather than as
     something to scroll to. */
  .scrim{scrollbar-width:none;-ms-overflow-style:none}
  .scrim::-webkit-scrollbar{width:0;height:0;background:transparent}
  .m-scroll,.done,.field textarea{scrollbar-width:thin;scrollbar-color:var(--w-amber) transparent}
  .m-scroll::-webkit-scrollbar,
  .done::-webkit-scrollbar,
  .field textarea::-webkit-scrollbar{width:5px;height:5px;background:transparent}
  .m-scroll::-webkit-scrollbar-thumb,
  .done::-webkit-scrollbar-thumb,
  .field textarea::-webkit-scrollbar-thumb{background:var(--w-amber)}

  .grid2{display:grid;grid-template-columns:1fr 1fr;gap:13px}
  .span2{grid-column:1 / -1}
  .field{display:flex;flex-direction:column;gap:5px;min-width:0;position:relative}
  .field>label{
    font-family:var(--w-mono);font-size:10px;letter-spacing:.24em;line-height:1.45;
    text-transform:uppercase;color:rgba(238,237,227,.5);
  }
  .field .opt{color:var(--w-mute-2)}

  /* HAIRLINE FIELDS — Aldo's treatment. No wells: the control is a single
     bottom rule, which is the language Three Nights uses everywhere else
     (.hours-row, .menu-row, .faq-item are all hairline-separated).

     The state signal moves from an inset rail to the rule itself:
        rest     bone @ .22
        hover    bone @ .40
        focus    amber
        filled   green   — has an answer
        invalid  ember
     "Filled" means it HAS characters, not that they are valid, so it stands
     down for the error state — otherwise a malformed email would wear the
     success colour while wrong. */
  .field input,.field select,.field textarea{
    font-family:var(--w-ff);font-weight:300;
    font-size:16px;                    /* 16px stops iOS zooming on focus */
    color:var(--w-ink);background:transparent;
    border:0;border-bottom:1px solid rgba(238,237,227,.22);border-radius:0;
    padding:9px 0;width:100%;box-shadow:none;
    transition:border-color .22s ease,background .22s ease;
  }
  .field textarea{resize:vertical;min-height:66px;font-size:15px;line-height:1.55}
  .field input:hover,.field select:hover,.field textarea:hover{border-bottom-color:rgba(238,237,227,.40)}
  .field input:focus,.field select:focus,.field textarea:focus{
    outline:none;border-bottom-color:var(--w-amber-hot);box-shadow:none;
  }
  /* TRAP B, all three empty states dimmed the same way */
  .field input::placeholder,.field textarea::placeholder{color:var(--w-hint);opacity:1}
  /* Autofill still paints its own ground, and only a large inset shadow beats
     it. With no well to fill, that shadow has to be the MODAL's surface or the
     field reappears as a box the moment the browser fills it. */
  .field input:-webkit-autofill,
  .field input:-webkit-autofill:hover,
  .field input:-webkit-autofill:focus{
    -webkit-text-fill-color:var(--w-ink);
    caret-color:var(--w-ink);
    transition:background-color 8000s ease-in-out 0s;
    -webkit-box-shadow:inset 0 0 0 100px var(--w-panel);
  }
  .field:not(.is-filled) select{color:var(--w-hint)}
  .field:not(.is-filled) input[type="date"]{color:var(--w-hint)}
  .field input[type="number"]{-moz-appearance:textfield;appearance:textfield}
  .field input[type="number"]::-webkit-outer-spin-button,
  .field input[type="number"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
  .field select{appearance:none;cursor:pointer;padding-right:24px}
  .sel{position:relative}
  .sel::after{
    content:"";position:absolute;right:4px;top:17px;pointer-events:none;
    border:4px solid transparent;border-top-color:var(--w-amber-lit);
  }
  .field.is-filled:not(.is-invalid) input,
  .field.is-filled:not(.is-invalid) select,
  .field.is-filled:not(.is-invalid) textarea{
    border-bottom-color:var(--w-green);
  }
  .field.is-invalid input,.field.is-invalid select,.field.is-invalid textarea{
    border-bottom-color:var(--w-err);
  }
  .err{
    display:none;
    font-family:var(--w-mono);font-size:10.5px;letter-spacing:.1em;line-height:1.35;
    text-transform:uppercase;color:var(--w-err-lit);
  }
  .field.is-invalid .err{display:block}

  .m-foot{
    position:relative;flex:none;display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;
    margin:0;padding:14px 26px 22px;border-top:1px solid var(--w-line);
    background:var(--w-panel);
  }
  .m-foot::before{
    content:"";position:absolute;left:0;right:0;bottom:100%;height:24px;
    pointer-events:none;background:linear-gradient(transparent,var(--w-panel));
  }
  .m-foot p{margin:0;font-size:12.5px;color:var(--w-mute);max-width:34ch}
  .m-foot .cta{width:auto;justify-content:center;padding:13px 24px}
  .cta[disabled]{opacity:.6;cursor:progress}

  /* ── confirmation ── */
  .done{flex:1 1 auto;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:16px;padding:18px 26px 26px}
  .done-mark{
    width:46px;height:46px;border-radius:50%;background:var(--w-green);color:#fff;
    display:grid;place-items:center;font-size:22px;font-weight:700;
  }
  .done-h{font-family:var(--w-ff);font-weight:300;text-transform:uppercase;font-size:1.6rem;letter-spacing:.04em;line-height:1.1;margin-bottom:10px}
  .done-lede{color:var(--w-mute);font-size:15px;max-width:48ch}
  .done-lede b{color:var(--w-ink);font-weight:600}
  .summary{display:grid;gap:1px;background:var(--w-line);border:1px solid var(--w-line)}
  .summary>div{background:var(--w-ground);padding:11px 15px;display:flex;justify-content:space-between;gap:18px;font-size:13.5px}
  .summary dt{font-family:var(--w-mono);font-size:10.5px;letter-spacing:.18em;text-transform:uppercase;color:var(--w-amber-lit)}
  .summary dd{text-align:right;color:var(--w-ink)}
  .done-next{border-top:1px solid var(--w-line);padding-top:18px;display:flex;flex-direction:column;gap:12px}
  .done-actions{display:flex;gap:10px;flex-wrap:wrap}
  .done-actions .cta{width:auto;justify-content:center;padding:13px 20px}
  .done-fine{font-size:12.5px;color:var(--w-mute-2);max-width:52ch}
  /* It was an underlined text link sitting BELOW the fine print, and because
     .done-next is a flex column it stretched full width and centred its own
     label — so the one real action on this screen was both the faintest thing
     on it and the only thing not aligned with the rest. It is now a filled
     button in the actions row, level with Call. */
  .done-again{flex:0 1 auto}
  @media(max-width:620px){
    .done-actions{flex-direction:column;align-items:stretch}
    .done-actions .cta{width:100%}
  }

  /* SHORT VIEWPORTS.
     The constraint on this dialog is viewport HEIGHT, not width, so that is
     what it responds to. A single spacing scale cannot serve both: roomy
     enough to match the mock on a tall screen is ~640px of content, which
     overflows a 755px-tall laptop once the dialog is capped at 92svh and an
     error line appears. Rather than compromise everywhere, the tall-screen
     rhythm stays generous and short screens compact automatically.
     Nothing is removed and no type drops below 16px in the inputs, so iOS
     still will not zoom on focus. */
  @media(max-height:820px){
    .m-head{padding:14px 26px 10px}
    .m-title{font-size:24px;margin:4px 0 3px}
    .m-sub{font-size:13px}
    .m-scroll{padding:12px 26px 6px}
    .grid2{gap:9px}
    .field{gap:4px}
    .field input,.field select,.field textarea{padding:9px 12px}
    .field textarea{min-height:52px}
    .sel::after{top:19px}
    .m-foot{padding:10px 26px 14px}
    .m-foot .cta{padding:11px 22px}
  }
  /* MOBILE.
     Single column means nine stacked fields — taller than any phone, always.
     So rather than fight it: the dialog becomes a full-screen sheet (no scrim
     gutter, no height cap) to use every available pixel, and the scroll box
     gets its scrollbar BACK.

     The hidden-chrome rule above is right on desktop, where the panel usually
     fits and a grey bar just looks broken. Here it is wrong: the form must
     scroll, and with no bar there is nothing telling the user that. A slim
     amber thumb matches the theme and restores the affordance.

     The header and footer stay pinned, so Send is on screen throughout. */
  @media(max-width:620px){
    .scrim{padding:0;align-items:stretch;justify-content:stretch}
    .m-head{padding-top:76px}
    .modal{width:100%;max-height:100svh;min-height:100svh;border-left:0;border-right:0;border-bottom:0}
    .grid2{grid-template-columns:1fr}
    .m-head{padding:16px 20px 12px}
    .m-scroll{padding:16px 20px 8px}
    .m-foot{padding:12px 20px 16px}
    .done{padding:18px 20px 22px}
    .m-foot .cta{width:100%}
  }
  @media(prefers-reduced-motion:reduce){
    .fab,.cta,.field input,.field select,.field textarea{transition:none}
    .fab::before,.panel,.modal{animation:none}
    .fab:hover,.cta:hover{transform:none}
    .cta:hover .arr{transform:none}
  }
  `;

  var HTML = `
  <div class="panel" id="panel" role="dialog" aria-label="Three ways to reach ALIA" hidden>
    <p class="p-title">Three ways in</p>
    <p class="p-sub">Which one are you here for?</p>
    <button type="button" class="cta primary" data-act="corp">
      <span class="lab"><span class="sub">Priority</span>Corporate · Private events</span><span class="arr">&rarr;</span>
    </button>
    <a class="cta ghost" href="${CFG.openTable}" target="_blank" rel="noopener">
      <span class="lab">Restaurant · Book a table</span><span class="arr">&rarr;</span>
    </a>
    <a class="cta ghost" href="${CFG.phoneHref}">
      <span class="lab">Club · Call the door</span><span class="arr">&rarr;</span>
    </a>
    <p class="p-note">${CFG.phoneLabel}</p>
  </div>

  <button class="fab" id="fab" type="button" aria-label="How to reach us" aria-expanded="false" aria-controls="panel">?</button>

  <div class="scrim" id="scrim">
    <div class="modal" role="dialog" aria-modal="true" aria-labelledby="m-title">
      <div class="m-head">
        <div>
          <p class="m-eye">Private events</p>
          <h2 class="m-title" id="m-title">Request a date</h2>
          <p class="m-sub" id="m-sub">Tell us the date and the headcount and we will come back to you.</p>
        </div>
        <button class="m-x" id="m-x" type="button" aria-label="Close">&#10005;</button>
      </div>

      <div class="m-body">
        <form id="form" novalidate>
          <div class="m-scroll">
          <div class="grid2">
            <div class="field">
              <label for="f-name">Your name</label>
              <input id="f-name" name="Name" type="text" autocomplete="name" placeholder="Full name"
                     maxlength="80" data-empty="Enter your name" data-bad="Enter your full name" required>
              <span class="err">Enter your name</span>
            </div>
            <div class="field">
              <label for="f-company">Company or organisation</label>
              <input id="f-company" name="Company" type="text" autocomplete="organization" placeholder="Company"
                     maxlength="80" data-empty="Enter the company or organisation" required>
              <span class="err">Enter the company or organisation</span>
            </div>
            <div class="field">
              <label for="f-email">Work email</label>
              <input id="f-email" name="Email" type="email" autocomplete="email" placeholder="you@company.com"
                     maxlength="120" pattern="[^@\s]+@[^@\s]+\.[^@\s]{2,}"
                     data-empty="Enter your work email"
                     data-bad="That does not look like an email, check for a typo" required>
              <span class="err">Enter your work email</span>
            </div>
            <div class="field">
              <label for="f-phone">Phone number</label>
              <input id="f-phone" name="Phone" type="tel" autocomplete="tel" placeholder="514 555 0142"
                     inputmode="tel" maxlength="24" data-empty="Enter a phone number"
                     data-bad="Enter at least 10 digits" required>
              <span class="err">Enter a phone number</span>
            </div>
            <div class="field">
              <label for="f-event">What kind of event?</label>
              <div class="sel">
                <select id="f-event" name="Event type" required>
                  <option value="" selected>Choose one</option>
                  <option>Year-end party</option>
                  <option>Client dinner</option>
                  <option>Full buyout</option>
                  <option>Cocktail reception</option>
                  <option>Product launch</option>
                  <option>Something else</option>
                </select>
              </div>
              <span class="err">Choose an event type</span>
            </div>
            <div class="field span2" id="other-wrap" hidden>
              <label for="f-other">Tell us what you are planning</label>
              <input id="f-other" name="Event detail" type="text" placeholder="A product launch, an awards night…"
                     maxlength="120" data-empty="Tell us what you are planning">
              <span class="err">Add a short description</span>
            </div>
            <div class="field">
              <label for="f-guests">How many guests?</label>
              <input id="f-guests" name="Guests" type="text" inputmode="numeric" placeholder="e.g. 60"
                     maxlength="4" data-empty="How many guests?"
                     data-bad="Enter a number between 1 and 400" required>
              <span class="err">Enter a number</span>
            </div>
            <div class="field">
              <label for="f-date">Preferred date</label>
              <input id="f-date" name="Preferred date" type="date" data-empty="Choose a date"
                     data-bad="Choose a date from today onwards" required>
              <span class="err">Choose a date</span>
            </div>
            <div class="field">
              <label for="f-budget">Budget per guest <span class="opt">(optional)</span></label>
              <div class="sel">
                <select id="f-budget" name="Budget per head">
                  <option value="" selected>Not sure yet</option>
                  <option>$95 to $150</option>
                  <option>$150 to $225</option>
                  <option>$225 and up</option>
                </select>
              </div>
            </div>
            <div class="field span2">
              <label for="f-notes">Anything we should know <span class="opt">(optional)</span></label>
              <textarea id="f-notes" name="Notes" placeholder="Dietary needs, AV, a speech, a hard end time."></textarea>
            </div>
          </div>
          </div>
          <div class="m-foot">
            <p id="m-fine"></p>
            <button class="cta primary" type="submit" id="submit"><span class="lab">Send request</span></button>
          </div>
        </form>

        <div class="done" id="done" hidden aria-live="polite">
          <div class="done-mark" aria-hidden="true">&#10003;</div>
          <div>
            <h3 class="done-h" id="done-h">Thank you.</h3>
            <p class="done-lede" id="done-lede"></p>
          </div>
          <dl class="summary" id="summary"></dl>
          <div class="done-next">
            <p class="m-eye">If you need us sooner</p>
            <div class="done-actions">
              <a class="cta ghost" href="${CFG.phoneHref}"><span class="lab">Call ${CFG.phoneLabel}</span></a>
              <button type="button" class="cta primary done-again" id="done-again" hidden><span class="lab">Send another request</span></button>
            </div>
            <p class="done-fine" id="done-fine"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  `;

  /* ─────────────────────────── mount ─────────────────────────── */
  var host = document.createElement('div');
  host.id = 'alia-wgt-host';
  /* Lenis sees the retargeted host, not our inner nodes, so the opt-out
     attribute belongs here or touch scrolling inside the dialog dies. */
  host.setAttribute('data-lenis-prevent', '');
  document.body.appendChild(host);
  var root = host.attachShadow({ mode: 'open' });
  root.innerHTML = '<style>' + CSS + '</style>' + HTML;

  /* the theme's own sticky dock shares this corner and is a strict subset of
     the widget's actions, so it stands down */
  var hide = document.createElement('style');
  hide.id = 'alia-wgt-dock-hide';
  hide.textContent = '.alia-cta-dock{display:none!important}';
  document.head.appendChild(hide);

  var $ = function (s) { return root.getElementById(s); };
  var fab = $('fab'), panel = $('panel'), scrim = $('scrim'), form = $('form');
  var done = $('done'), summary = $('summary'), submit = $('submit');
  var otherWrap = $('other-wrap'), otherInput = $('f-other'), eventSel = $('f-event');

  /* A service note, as in the mock. The prefilled-email mechanics are
     explained on the confirmation screen instead of pre-emptively here. */
  $('m-fine').textContent = 'We will confirm availability and a starting menu.';

  /* ── panel ── */
  function setPanel(open) {
    panel.hidden = !open;
    fab.textContent = open ? '✕' : '?';
    fab.classList.toggle('open', open);
    fab.setAttribute('aria-expanded', String(open));
    fab.setAttribute('aria-label', open ? 'Close' : 'How to reach us');
  }
  fab.addEventListener('click', function (e) { e.stopPropagation(); setPanel(panel.hidden); });
  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    var p = e.composedPath();
    if (p.indexOf(panel) === -1 && p.indexOf(fab) === -1) setPanel(false);
  });

  /* ── modal ── */
  /* This theme keeps its single Lenis instance on the app namespace, not on
     window.ALIA_LENIS the way Bassline does. Check both, so the same file
     keeps working if it is ported on again. */
  function lenis() {
    var ns = window.__ALIA_AFTER_DARK__;
    return window.ALIA_LENIS || (ns && ns.lenis) || null;
  }
  var lastFocus = null;

  /* SESSION GUARD
     The commonest duplicate is not a double-click — that is already covered by
     disabling the button before the fetch. It is someone who sends a request,
     closes the modal, reopens it out of curiosity and finds their details still
     typed in behind a live Send button.

     So a delivered request is remembered for the browser session and reopening
     lands on the confirmation instead of a primed form. sessionStorage, not
     localStorage: it survives closing the modal and moving between pages, and
     clears with the tab. It must never HARD block a second enquiry — one
     browser is not one person, and a genuine second request is worth far more
     than the duplicate row it might cost. Hence the escape hatch. */
  var SENT_KEY = 'alia-req-sent';

  function readSent() {
    try { return JSON.parse(sessionStorage.getItem(SENT_KEY) || 'null'); }
    catch (err) { return null; }   /* private mode / storage disabled */
  }
  function rememberSent(p) {
    try { sessionStorage.setItem(SENT_KEY, JSON.stringify({ data: p.data, text: p.text })); }
    catch (err) {}
  }
  function forgetSent() {
    try { sessionStorage.removeItem(SENT_KEY); } catch (err) {}
  }

  function openModal() {
    lastFocus = document.activeElement;
    setPanel(false);

    var prior = readSent();
    if (prior) {
      confirmView(prior, true, true);
      scrim.classList.add('on');
      var lp = lenis(); if (lp && lp.stop) lp.stop();
      return;
    }

    /* a second enquiry must never open onto the previous one's confirmation */
    form.hidden = false; done.hidden = true;
    $('m-title').textContent = 'Request a date';
    $('m-sub').textContent = 'Tell us the date and the headcount and we will come back to you.';
    scrim.classList.add('on');
    var l = lenis(); if (l && l.stop) l.stop();
    setTimeout(function () { $('f-name').focus(); }, 30);
  }
  function closeModal() {
    scrim.classList.remove('on');
    var l = lenis(); if (l && l.start) l.start();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  /* The escape hatch. Clearing the flag AND the fields matters: a returning
     visitor sending a second request is almost always a different event, not a
     correction of the first. */
  $('done-again').addEventListener('click', function () {
    forgetSent();
    form.reset();
    fields.forEach(function (f) {
      delete f.dataset.touched;
      f.classList.remove('is-filled', 'is-invalid');
    });
    syncAll();
    done.hidden = true; form.hidden = false;
    $('m-title').textContent = 'Request a date';
    $('m-sub').textContent = 'Tell us the date and the headcount and we will come back to you.';
    $('f-name').focus();
  });

  $('m-x').addEventListener('click', closeModal);
  scrim.addEventListener('click', function (e) { if (e.target === scrim) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (scrim.classList.contains('on')) closeModal();
    else if (!panel.hidden) setPanel(false);
  });

  /* TRAP A — ONE handler, on document, walking composedPath(). This is what
     makes every Corporate button on the page work, not just the two in here. */
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.getAttribute && el.getAttribute('data-act') === 'corp') {
        e.preventDefault();
        openModal();
        return;
      }
    }
  });

  /* ── conditional "Something else" ──
     TRAP H — a hidden control that is still `required` fails checkValidity()
     on something the browser cannot focus or scroll to, so the form refuses
     to submit with nothing on screen explaining why. Toggle required WITH
     visibility, never independently. */
  function syncOther() {
    var other = eventSel.value === 'Something else';
    otherWrap.hidden = !other;
    if (other) {
      otherInput.setAttribute('required', '');
      /* it appears mid-form and pushes everything below it down, so bring it
         into view instead of leaving the user to wonder what moved */
      otherWrap.scrollIntoView({ block: 'nearest' });
    }
    else { otherInput.removeAttribute('required'); otherInput.value = ''; otherWrap.classList.remove('is-invalid', 'is-filled'); }
  }
  eventSel.addEventListener('change', syncOther);
  syncOther();

  /* ── field state ──
     State lives on the .field WRAPPER, so every rule sits at one specificity
     tier and the CSS order IS the priority order. It also sidesteps
     :placeholder-shown, which never reports a date input or an unchosen
     <select> as empty. */
  var fields = [].slice.call(form.querySelectorAll('.field'));

  /* No enquiries for dates that have already passed. Built from the LOCAL
     date, not toISOString() — that is UTC, so anyone in Montreal filling this
     in after 8pm would be offered tomorrow as the earliest date. */
  (function () {
    var d = new Date();
    var local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    $('f-date').min = local.toISOString().slice(0, 10);
  })();
  function ctrl(f) { return f.querySelector('input, select, textarea'); }
  /* ── SANITISE ──────────────────────────────────────────────────────────
     Runs on every keystroke and on paste. Strips what can never be valid
     rather than waiting to reject it, so the field simply refuses to hold a
     letter in a phone number instead of complaining after the fact.
     The caret has to be restored by hand: assigning .value moves it to the
     end, which makes editing the middle of a number impossible. */
  function sanitise(c) {
    var before = c.value, after = before;
    if (c.id === 'f-guests')      after = before.replace(/\D/g, '');
    else if (c.id === 'f-phone')  after = before.replace(/[^\d+()\-.\s]/g, '');
    else return;
    if (after === before) return;
    var drop = before.length - after.length;
    var pos = (c.selectionStart || after.length) - drop;
    c.value = after;
    try { c.setSelectionRange(pos, pos); } catch (err) {}
  }

  /* ── RULES THE BROWSER HAS NO TYPE FOR ─────────────────────────────────
     setCustomValidity marks the control invalid; the message shown comes
     from data-bad, so the copy stays with the markup. */
  function customCheck(c) {
    c.setCustomValidity('');
    var v = String(c.value || '').trim();
    if (!v) return;                       /* emptiness is `required`'s job */

    if (c.id === 'f-guests') {
      var n = parseInt(v, 10);
      if (!(n >= 1 && n <= 400)) c.setCustomValidity('out of range');
    } else if (c.id === 'f-phone') {
      /* 10 digits is the shortest real North American number. Punctuation and
         a country code are allowed through, they just do not count. */
      if (v.replace(/\D/g, '').length < 10) c.setCustomValidity('too short');
    } else if (c.id === 'f-name') {
      if (v.length < 2 || !/[A-Za-zÀ-ɏ]/.test(v)) c.setCustomValidity('not a name');
    }
  }

  function syncField(f) {
    var c = ctrl(f); if (!c) return;
    sanitise(c);
    customCheck(c);
    f.classList.toggle('is-filled', String(c.value || '').trim() !== '');
    if (f.dataset.touched !== '1') return;

    var ok = c.checkValidity();
    f.classList.toggle('is-invalid', !ok);
    /* Empty and wrong are different problems and deserve different words.
       "Required" under a half-typed email tells the guest nothing. */
    if (!ok) {
      var msg = f.querySelector('.err');
      if (msg) msg.textContent = (c.validity.valueMissing && c.dataset.empty)
        ? c.dataset.empty
        : (c.dataset.bad || c.dataset.empty || 'Required');
    }
  }
  function syncAll() { fields.forEach(syncField); }
  fields.forEach(function (f) {
    var c = ctrl(f); if (!c) return;
    c.addEventListener('input', function () { syncField(f); });
    c.addEventListener('change', function () { syncField(f); });
    c.addEventListener('blur', function () { f.dataset.touched = '1'; syncField(f); });
  });
  syncAll();

  $('f-date').min = new Date().toISOString().slice(0, 10);

  function niceDate(iso) {
    try {
      var p = iso.split('-');
      return new Date(p[0], p[1] - 1, p[2]).toLocaleDateString('en-CA',
        { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
    } catch (err) { return iso; }
  }

  function collect() {
    var data = {}, lines = [];
    summary.innerHTML = '';
    [].forEach.call(form.elements, function (el) {
      if (!el.name) return;
      var val = String(el.value || '').trim();
      if (!val) return;
      var shown = el.name === 'Preferred date' ? niceDate(val) : val;
      data[el.name] = val;
      var row = document.createElement('div');
      var dt = document.createElement('dt'); dt.textContent = el.name;
      var dd = document.createElement('dd'); dd.textContent = shown;
      row.appendChild(dt); row.appendChild(dd);
      summary.appendChild(row);
      lines.push(el.name + ': ' + shown);
    });
    return { data: data, text: lines.join('\n') };
  }

  function confirmView(p, delivered, returning) {
    var first = (p.data.Name || '').trim().split(/\s+/)[0];
    $('m-title').textContent = returning ? 'Already sent' : 'Request received';
    $('m-sub').textContent = returning ? 'We have this one.'
      : (delivered ? 'The events team has it.' : 'One more step.');
    $('done-h').textContent = returning ? (first ? 'You are all set, ' + first + '.' : 'You are all set.')
      : (delivered ? (first ? 'Thank you, ' + first + '.' : 'Thank you.') : 'Give us a call.');
    $('done-lede').innerHTML = 'Your request for <b>' + (p.data.Guests || '') + ' guests</b> on <b>' +
      niceDate(p.data['Preferred date'] || '') + '</b> is with the events team, and we will come back to you about ' +
      'availability and a starting menu.';
    $('done-fine').textContent = delivered
      ? 'A copy of this request is with the events team.'
      : 'We could not submit this automatically. Please call ' + CFG.phoneLabel + ' with your date and guest count and the team will pick it up.';
    /* Reopening rebuilds the summary from storage — the live one was written
       into the DOM by collect() during the original submit and is long gone. */
    if (returning) renderSummary(p);
    $('done-again').hidden = !returning;

    form.hidden = true; done.hidden = false;
    done.scrollIntoView({ block: 'nearest' });
  }

  function renderSummary(p) {
    summary.innerHTML = '';
    Object.keys(p.data).forEach(function (k) {
      if (k === 'Site' || k === 'Page') return;   /* plumbing, not the guest's answers */
      var row = document.createElement('div');
      var dt = document.createElement('dt'); dt.textContent = k;
      var dd = document.createElement('dd');
      dd.textContent = k === 'Preferred date' ? niceDate(p.data[k]) : p.data[k];
      row.appendChild(dt); row.appendChild(dd);
      summary.appendChild(row);
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    fields.forEach(function (f) { f.dataset.touched = '1'; });
    syncAll();
    if (!form.checkValidity()) {
      var bad = form.querySelector('.field.is-invalid input, .field.is-invalid select, .field.is-invalid textarea');
      if (bad) bad.focus();
      return;
    }

    var p = collect();
    /* These keys ARE the sheet's column headers. The Apps Script matches on
       header TEXT, so renaming one here silently stops that column filling —
       no error anywhere, the column just goes quiet.
         Leads sheet: Received | Site | Page | Name | Company | Email | Phone |
                      Event type | Event detail | Guests | Preferred date |
                      Budget per head | Notes | Status
       "Received" is stamped server side and "Status" is filled by hand, so we
       send neither. "Event detail" has its own column — do not fold it into
       Event type. */
    p.data.Site = CFG.site;
    p.data.Page = location.href;

    /* No endpoint configured means the form genuinely cannot deliver. Say
       so and give the phone number — promising a reply nobody will receive
       is worse than admitting the form is not wired up. */
    if (DEMO) { confirmView(p, false); return; }

    submit.disabled = true;
    submit.querySelector('.lab').textContent = 'Sending';
    /* text/plain avoids a CORS preflight, which Apps Script endpoints reject */
    fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(p.data)
    }).then(function () {
      rememberSent(p);
      confirmView(p, true);
    }).catch(function () {
      /* Only a genuine network/CORS failure reaches here. Apps Script returns
         an opaque response on success, which resolves, so this is not the
         "did the row actually write" check — the sheet is. */
      confirmView(p, false);
    }).then(function () {
      submit.disabled = false;
      submit.querySelector('.lab').textContent = 'Send request';
    });
  });
})();
